import React, { useCallback, useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import completedImage from "../../assests/images/Completed.png";
import purchaseImage from "../../assests/images/Purchase.png";
import pendingImage from "../../assests/images/Pending.png";
import shippedImage from "../../assests/images/Shipped.png";
import LayersIcon from "@mui/icons-material/Layers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import checkcircleImage from "../../assests/images/check-circle.png";
import holdImage from "../../assests/images/hold.png";
import rejectImage from "../../assests/images/Reject.png";
import releasedImage from "../../assests/images/Release.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import esignpdfImages from "../../assests/images/esignpdf.png";
import checkImage from "../../assests/images/check-circle.png";
import { UserObj } from "../../services/localStarage";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Drawer from "@mui/material/Drawer";
import PropTypes from "prop-types";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import _, { method } from "lodash";
import { getSecPermission, isEmptyDash, returnRateVal, returnZero, strToDate, totalInr, trimString } from "../../constant";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import Filter from "../filter/filter";
import { downloadFile } from "./index";
import RequestSignModal from "./requestSignModal";
import PDFPreview from "./pdfPreview";
import POReleaseModal from "./releaseModal";
import { onboardingServices } from "../../services/onboardingServices";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import TrackOrder from "../common/trackOrder";
import { commonServices } from "../../services/commonServices";

const initialColumns = [
  { id: "poNumber", label: "PO Number", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "sapPoCode", label: "SAP PO Code", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "vendorCode", label: "Vendor Code", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "vendorName", label: "Vendor Name", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "poType", label: "PO Category", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "companyCode", label: "Company ID", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "paymentTerms", label: "Payment Terms", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "buyerName", label: "Buyer Name", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "orderDate", label: "Order Date", isSort: true, sortLabel: "", formate: "DATE" },

  { id: "version", label: "Version", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "deliveryStatus", label: "Delivery Status", isSort: true, sortLabel: "", formate: "TEXT" },
  // { id: "createdAt", label: "Created On", isSort: true, sortLabel: "", formate: "DATE" },
  { id: "lastUpdated", label: "Updated On", isSort: true, sortLabel: "", formate: "DATE" },

  { id: "totalQuantity", label: "Total Quantity", isSort: true, sortLabel: "", formate: "QTY" },
  // { id: "poQty", label: "PO Qty", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "deliveredQty", label: "Received Qty", isSort: true, sortLabel: "", formate: "QTY" },
  { id: "pendingQty", label: "Pending Qty", isSort: true, sortLabel: "", formate: "QTY" },
  { id: "netValue", label: "Net Value", isSort: true, sortLabel: "", formate: "TEXT" , formate: "RATE"},
  { id: "status", label: "Status", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "actions", label: "Actions", isSort: false, sortLabel: "", formate: "TEXT" },
];

const requestesignstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const extendvaliditystyle1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const steps = [
  {
    label: "PO Creation",
    text: "Created on : 12-02-2024",
    description: `Created At : 10:00`,
    remarks: `Created By : Sanjeev`,
    headings: "QC0001",
    headings2: "QC0002",
  },
  {
    label: "PO Approval",
    text: "Approved on : 12-02-2024",
    description: `Approved By : Sanjeev`,
    headings: "QC0001",
    headings2: "QC0002",
  },
  {
    label: "QC Creation : QC0001, QC0002",
    headings: "QC0001",
    text: "Approved on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `Approved By : Sanjeev`,
    headings2: "QC0002",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Creation : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0002",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "QC Creation : QC0003, QC0004",
    headings: "QC0003",
    text: "QC Created on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `QC Created By : Sanjeev`,
    headings2: "QC0004",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Delivered : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0004",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "Gate Creation : GE0001, GE0002",
    headings: "GE0001",
    text: "GE Created on : 12-02-2024",
    remarks: "GE Created At : 10:00",
    description: `GE Created By : Sanjeev`,
    headings2: "GE0002",
    remarks2: "GE Created on : 12-02-2024",
    description2: "GE Created At : 10:00",
    text2: "GE Created By : Sanjeev"
  },
  {
    label: "GRN Creation : GRN0001, GRN0002",
    headings: "GRN0001",
    text: "GRN Created on : 12-02-2024",
    remarks: "GRN Created At : 10:00",
    description: `GRN Created By : Sanjeev`,
    headings2: "GRN0002",
    remarks2: "GRN Created on : 12-02-2024",
    description2: "GRN Created At : 10:00",
    text2: "GRN Created By : Sanjeev"
  },

  // Add more steps if needed...
];
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const permissionInit = {
  create: false,
  read: false,
  update: false,
  delete: false,
};

function PurchaseOrder() {

  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [polisting, setPOListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    purchaseOrders: [],
  });

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [downloadEl, setdownloadEl] = React.useState(null);
  const [openapprovepurchasetModal, setOpenApprovePurchaseModal] =
    useState(false);
  const [openapprovesucessfullyModal, setOpenApproveSucessfullyModal] =
    useState(false);
  const [openapprovebulkModal, setOpenApproveBulkModal] = useState(false);
  const [openrequestedeasysignModal, setOpenRequestedEasySignModal] =
    useState(false);
  const [openesignpdfmodal, setopenESignPdfModal] = useState(false);
  const [openaddmildstonemodals, setOpenAddMildStoneModals] = useState(false);
  const [openmilestonesuccessfullymodal, setOpenMilestoneSuccessfullyModal] =
    useState(false);
  const [opencustomtscmodal, setOpenCusTomtscModal] = useState(false);
  const [opencustomtscmodalsuccessfully, setOpenCustomTscModalSuccessfully] =
    useState(false);
  const [openholdModal, setOpenHoldModal] = useState(false);
  const [openholdsucessfullyModal, setOpenHoldSucessfullyModal] =
    useState(false);
  const [openholdbulkModal, setOpenHoldBulkModal] = useState(false);
  const [openrejectedModal, setOpenRejectedModal] = useState(false);
  const [openrejectedsucessfullyModal, setOpenRejectedSuccessfullyModal] =
    useState(false);
  const [openrejectedbulkModal, setOpenRejectedBulkModal] = useState(false);
  const [openrreleasedModal, setOpenReleasedModal] = useState(false);
  const [openrreleasedsuccessfullyModal, setOpenReleasedSuccessfullyModal] =
    useState(false);
  const [openconfirmationdetails, setOpenConfirmationDetails] = useState(false);
  const [openextendvalidityremarksmodal, setOpenExtendValidityRemarksModal] =
    useState(false);
  const [openaddmilestonepaymentmodal, setOpenAddMilestonePaymentModal] =
    useState(false);
  const [openheaderlevelexcelmodal, setOpenHeaderLevelExcelModal] =
    useState(false);
  const [confirmObj, setConfirmObj] = useState({});
  const [openheaderlevelsucessfullymodal, setOpenHeaderLevelSucessfullyModal] =
    useState(false);
  const [openheaderlevelrejectedmodal, setOpenHeaderLevelRejectedModal] =
    useState(false);
  const [openlineitemlevelexcelmodal, setOpenLineItemLevelExcelModal] =
    useState(false);
  const [openlineitemlevelsuccessmodal, setOpenLineItemLevelSuccessModal] =
    useState(false);
  const [openlineitemlevelrejectedmodal, setOpenLineItemLevelRejectedModal] =
    useState(false);
  const [openrelaseesignmodals, setopenRelaseESignModals] = useState(false);
  const [openrelaseesignsuccessmodals, setopenRelaseESignSuccessModals] =
    useState(false);
  const [openrelaseesignrejectedmodals, setopenRelaseESignRejectedModals] =
    useState(false);
  const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  const [openpopdfpurchasesuccessmodal, setOpenPoPdfPurchaseSuccessModal] =
    useState(false);
  const [openpopdfpurchaserejectedmodal, setOpenPoPdfPurchaseRejectedModal] =
    useState(false);
  const [openreleaseorderpurchase, setOpenReleaseOrderPurchase] =
    useState(false);
  const [openreleaseorderpurchasepdf, setOpenReleaseOrderPurchasePdf] =
    useState(false);
  const [openreleaseordermessagepdf, setOpenReleaseOrderMessagePdf] =
    useState(false);
  const [openreleaseordersuccessmessage, setOpenReleaseOrderSuccessMessage] =
    useState(false);
  const [openundoreleasemodal, setOpenUndoReleaseModal] = useState(false);
  const [openapproveesign, setOpenApproveEsign] = useState(false);
  const [openapproveesignsucessmodal, setOpenApproveEsignSuccessModal] =
    useState(false);
  const [opemholdesignmodal, setOpemHoldESignModal] = useState(false);
  const [opemholdesignmodalsuccess, setOpemHoldESignModalSuccess] = useState(false);
  const [opemrejectesignmodal, setOpemRejectESignModal] = useState(false);
  const [opemrejectesignmodalsuccess, setOpemRejectESignModalSuccess] = useState(false);

  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [selectedPOArr, setSelectedPOArr] = useState([]);
  const [selectedPOJsonArr, setSelectedPOJsonArr] = useState([]);
  const [filterFormData, setFilterFormData] = useState("");
  const [trackOrderData, setTrackOrderData] = useState("");
  const [inputPage, setInputPage] = useState(polisting?.currentPage || 1);


  const [secPOPermission, setSecPOPermission] = useState({
    "PURCHASE_ORDER_LISTING": permissionInit,
    "PURCHASE_ORDER_DETAIL": permissionInit,
    "WITH_ESIGN": permissionInit,
    "ACCEPT_PO": permissionInit,
    "HOLD_PO": permissionInit,

    "REJECT_PO": permissionInit,
    "RELEASE": permissionInit,
    "UNDO_RELEASE": permissionInit,
    "TRACK_ORDER_PO": permissionInit,
    "DOWNLOAD_PO": permissionInit,
  });
  const [summary, setSummary] = React.useState({});

  const userRole = UserObj ? UserObj?.role?.name : "";
  const [checked, setChecked] = React.useState(true);

  const [poDetails, setPODetails] = React.useState({});
  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };
  const handleChangeswich = (event) => {
    setChecked(event.target.checked);
  };

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const [columns, setColumns] = useState(initialColumns);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const reorderedColumns = reorder(
      columns,
      result.source.index,
      result.destination.index
    );
    setColumns(reorderedColumns);
  };
  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });
  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  useEffect(() => {
    getPOListing(requestPayload, filterText, filterFormData);
  }, [requestPayload]);


  useEffect(() => {
    let secPOPermissionInit = _.cloneDeep(secPOPermission);
    let obj = {};
    for (let key in secPOPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecPOPermission(obj);
    getSummary("?uniqueName=PURCHASE_ORDER");

  }, []);

  const getSummary = (param) => {
    setIsLoading(true);
    let promise = commonServices.getSummary(param);
    promise.then((res) => {
      if (res.data.success === true) {
        setSummary(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getPOListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    let promise = purchaseOrderServices.getPurchaseOrderListing(param);
    promise.then((res) => {
      if (res.data.success === true) {
        setPOListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const redirectToDetails = (redirectId) => {
    const UserObjInit = JSON.parse(sessionStorage.getItem('user'));
    let param = {
      requestPayload: requestPayload,
      filterText: filterText,
      filterFormData: filterFormData,
      componentName: "PURCHASE_ORDER_LIST",
    };
    UserObjInit["prevLocationData"] = param;
    sessionStorage.setItem("user", JSON.stringify(UserObjInit));
    navigateUrl(`/admin/po-detail-services/${redirectId}`);
  };

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getPOListing(requestPayload, filterText);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);

    }, 800),
    []
  );

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }
  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= polisting?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(polisting?.currentPage);
      }
    }
  };

  const handleFilterFormSubmit = (formDataa) => {
    setFilterFormData(formDataa);
    const updatedPayload = {
      ...requestPayload,
      searchCriteria: formDataa,
    };
    setRequestPayload(updatedPayload);
    getPOListing(updatedPayload, filterText, formDataa || '');
  };

  const handleResetFormSubmit = () => {
    setFilterFormData(null);
    getPOListing(requestPayload, filterText, {});
  }

  const onPOCheckChange = (value, row, rowIndex) => {
    let polistingInit = _.cloneDeep(polisting);
    polistingInit.purchaseOrders[rowIndex].isChecked = value;
    let arr = [];
    let jsonArr = [];
    for (let i = 0; i < polistingInit.purchaseOrders.length; i++) {
      if (polistingInit.purchaseOrders[i].isChecked == true) {
        arr.push(polistingInit.purchaseOrders[i]._id);
        jsonArr.push(polistingInit.purchaseOrders[i]);
      }
    }
    setSelectedPOArr(arr);
    setSelectedPOJsonArr(jsonArr);
    setPOListing(polistingInit);
  }

  const openConfirmModal = (param) => {
    // if (selectedPOArr.length < 1) {
    //   setAlertComponent({ open: true, type: "error", message: `Please select atleast one Purchase Order. ` });
    //   return;
    // }
    let obj = {};
    obj["id"] = param;
    if (param == "header") {
      obj["text"] = "Header Level Excel";
    }
    if (param == "line-item") {
      obj["text"] = "Line Item Level Excel";
    }
    if (param == "po-pdf") {
      obj["text"] = "PO PDF";
    }
    setConfirmObj(obj);
    setOpenHeaderLevelExcelModal(true);
  }

  const closeConfirmModal = (param) => {
    setConfirmObj({});
    setOpenHeaderLevelExcelModal(false);
  }

  const downloadPO = () => {
    setIsLoading(true);
    let bodyData = {
      // "purchaseOrderIds": selectedPOArr,
      "type": confirmObj?.id, // "line-item", header, po-pdf
      ...filterFormData
    };

    if (!isEmptyDash(filterText)) {
      bodyData["search"] = filterText;
    }

    let fileName = "";
    // if (selectedPOArr.length > 1) {        
    //   if (confirmObj?.id == "header") {
    //     fileName = "PO_Header_Level_Excel.zip";
    //   }
    //   if (confirmObj?.id == "line-item") {
    //     fileName = "PO_Line_Item_Level_Excel.zip";
    //   }
    // } else {    
    //     if (confirmObj?.id == "header") {
    //       fileName = `${selectedPOJsonArr[0]?.poNumber}_HerderLevelExcel.xlsx`;
    //     }
    //     if (confirmObj?.id == "line-item") {
    //       fileName = `${selectedPOJsonArr[0]?.poNumber}_LineItemExcel.xlsx`;
    //     }
    // }
    if (confirmObj?.id == "header") {
      fileName = "PO_Header_Level_Excel.xlsx";
    }
    if (confirmObj?.id == "line-item") {
      fileName = "PO_Line_Item_Level_Excel.xlsx";
    }
    if (confirmObj?.id == "po-pdf") {
      fileName = `PO_PDF.zip`;
    }
    const data = {
      url: `/v1/common/purchase-orders/download`,
      bodyData: bodyData,
      method: "POST",
      fileName: fileName
    };
    downloadFile(data)
      .then(response => {
        if (isEmptyDash(response)) {
          setOpenHeaderLevelExcelModal(false);
          setOpenHeaderLevelSucessfullyModal(true);          
        } else {        
          setAlertComponent({ open: true, type: "success", message: `${response?.data?.message}` });          
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
      })
      .finally(() => {
        setIsLoading(false);
        setOpenHeaderLevelExcelModal(false);
      })

  }

  const openRequestSign = () => {
    getPODetails(selectedPOArr?.[0]);
  };

  const closeRequestSign = () => {
    setOpenAddMildStoneModals(false);
  };

  const submitSign = (bodyData) => {
    setIsLoading(true);
    purchaseOrderServices.poAddMileStones(bodyData)
      .then(response => {
        if (response?.data?.success == true) {
          setAlertComponent({ open: true, type: "success", message: `Milestone added successfully.` });
          closeRequestSign();
          getPOListing(requestPayload, filterText, filterFormData);
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });

  };


  const getPODetails = (param) => {
    setIsLoading(true);
    let url = `/${param}`;
    let promise = purchaseOrderServices.getPurchaseOrderListing(url);
    promise.then((res) => {
      if (res.data.success === true) {
        setPODetails(res.data?.data);
        setOpenAddMildStoneModals(true);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }


  const openPdfPreview = () => {
    setopenESignPdfModal(true);
  };

  const closePdfPreview = () => {
    setopenESignPdfModal(false);
  };

  const poTakeActionAPICall = (bodyData) => {
    purchaseOrderServices.poTakeAction(bodyData)
      .then(response => {
        if (confirmObj?.id == "Release") {
          setOpenReleasedModal(false)
          setOpenReleasedSuccessfullyModal(true);
        }
        else if (confirmObj?.id == "Reject") {
          setOpenRejectedModal(false);
          setOpenRejectedSuccessfullyModal(true);
        }
        else if (confirmObj?.id == "Undo Release") {
          setOpenUndoReleaseModal(false);
          setAlertComponent({ open: true, type: "success", message: `Status has been changed for selected POs. ` });
          // setOpenU(true);
        }
        else {
          setOpenPoPdfPurchaseSuccessModal(true);
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const submitPdfPreview = () => {
    setIsLoading(true);
    let bodyData = {
      "action": "Accept", //"Release", "Undo Release", "Reject"
      "purchaseOrderIds": [selectedPOArr?.[0]]
    };
    poTakeActionAPICall(bodyData);
  };

  const poTakeAction = () => {
    setIsLoading(true);
    let bodyData = {
      "action": confirmObj?.id, //"Release", "Undo Release", "Reject"
      "purchaseOrderIds": [selectedPOArr?.[0]]
    };
    poTakeActionAPICall(bodyData);
  }

  const openConfirmActionModal = (param) => {
    let obj = {};
    obj["id"] = param;
    if (param == "Accept") {
      obj["text"] = "Accept";
      setConfirmObj(obj);
      openPdfPreview();
    }
    if (param == "Release") {
      obj["text"] = "Release";
      setConfirmObj(obj);
      setOpenReleasedModal(true);
    }
    if (param == "Undo Release") {
      obj["text"] = "Undo Release";
      setConfirmObj(obj);
      setOpenUndoReleaseModal(true);
    }
    if (param == "Reject") {
      obj["text"] = "Reject";
      setConfirmObj(obj);
      setOpenRejectedModal(true);
    }
  }

  const openReleaseModal = () => {
    openConfirmActionModal("Release");
    setOpenReleasedModal(true);
  };

  const closeReleaseModal = () => {
    setOpenReleasedModal(false);
  };


  const uploadFile = (selectedFileParam) => {
    // e.preventDefault();
    let formData = new FormData();
    formData.append("file", selectedFileParam);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {
          let bodyData = {
            "action": "Release", //"Release", "Undo Release", "Reject"
            "poPdf": { // required in case action is Release
              "key": encodeKey(response?.data?.data?.data?.Key),
              "fileName": selectedFileParam?.name,
            },
            "purchaseOrderIds": selectedPOArr
          };
          poTakeActionAPICall(bodyData);
        }
      })
      .catch(function (error) {
        setAlertComponent(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };

  const handleTrackOrder = () => {
    if (selectedPOArr.length < 1) {
      setAlertComponent({ open: true, type: "error", message: `Please select atleast one Purchase Order. ` });
      return;
    }
    setIsLoading(true);
    purchaseOrderServices.getPOTrackOrder(selectedPOArr)
      .then(response => {
        if (response?.data?.success == true) {
          toggleDrawer(true)();
          setTrackOrderData(response?.data?.data);
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const DrawerList = (
    <TrackOrder steps={trackOrderData} close={() => toggleDrawer(false)()} refresh={() => handleTrackOrder()} />
  );

  return (
    <>
      <div className="login-forms">
        <div className="text-centers row_purchase_invoice_dragdropcontext_apps_body">
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_main">
                <h5>Purchase Order Listing</h5>
              </div>

              <div className="bpdt_po_order_react">

                <div>
                  {(userRole != "VENDOR") && <button
                    className="vendor_btn_bpdt_react_divs vendor_maine_contents"
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  >
                    <LayersIcon />
                    Action
                  </button>}
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    {/* {userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpenApprovePurchaseModal}>
                      Approve
                    </MenuItem>
                  ) : null} */}
                    {(secPOPermission["ACCEPT_PO"]?.read == true) ? (
                      <MenuItem onClick={openPdfPreview}>Accept</MenuItem>
                    ) : null}
                    {/* {userRole === "BUYER" ? (
                    <MenuItem onClick={setOpenAddMildStoneModals}>
                      Request E-Sign
                    </MenuItem>
                  ) : null} */}
                    {/* {userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpenAddMildStoneModals}>
                      Approve E-Sign
                    </MenuItem>
                  ) : null} */}
                    {/* {userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpemRejectESignModal}>Reject E-Sign</MenuItem>
                  ) : null}
                  {userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpemHoldESignModal}>Hold E-Sign</MenuItem>
                  ) : null} */}
                    {((secPOPermission["WITH_ESIGN"]?.read == true) && selectedPOArr.length == 1) ? (
                      <MenuItem onClick={openRequestSign}>
                        Request Sign
                      </MenuItem>
                    ) : null}
                    {/* {(secPOPermission["WITH_ESIGN"]?.read == true) ? (
                    <MenuItem onClick={setopenESignPdfModal}>E-Sign</MenuItem>
                  ) : null} */}
                    {(secPOPermission["RELEASE"]?.read == true) ? (
                      <MenuItem onClick={openReleaseModal}>
                        Release
                      </MenuItem>
                    ) : null}
                    {(secPOPermission["UNDO_RELEASE"]?.read == true) ? (
                      <MenuItem onClick={() => openConfirmActionModal("Undo Release")}>
                        Undo Release
                      </MenuItem>
                    ) : null}

                    {/* {userRole === "BUYER" ? (
                    <MenuItem onClick={setOpenApproveBulkModal}>
                      Approve Bulk
                    </MenuItem>
                  ) : null} */}
                    {/* {userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpenHoldModal}>Hold</MenuItem>
                  ) : null} */}
                    {/* {userRole === "BUYER" ? (
                    <MenuItem onClick={setOpenHoldBulkModal}>
                      Hold Bulk
                    </MenuItem>
                  ) : null} */}
                    {(secPOPermission["REJECT_PO"]?.read == true) ? (
                      <MenuItem onClick={() => openConfirmActionModal("Reject")}>Reject</MenuItem>
                    ) : null}
                    {/* {userRole === "BUYER" ? (
                    <MenuItem onClick={setOpenRejectedBulkModal}>
                      Reject Bulk
                    </MenuItem>
                  ) : null} */}

                    {/* {userRole === "BUYER" || userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpenReleasedModal}>Release</MenuItem>
                  ) : null} */}
                    {/* <MenuItem onClick={setopenRelaseESignModals}>
                    Realse E-sign
                  </MenuItem> */}
                    {/* {userRole === "MANAGER" ? (
                    <MenuItem onClick={setOpenExtendValidityRemarksModal}>
                      Extend Validity
                    </MenuItem>
                  ) : null} */}
                  </Menu>
                </div>
                <div>
                  {(secPOPermission["DOWNLOAD_PO"]?.read == true) && <button
                    className="vendor_btn_bpdt_react_divs vendor_maine_contents"
                    id="basic-button"
                    aria-controls={download ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={download ? "true" : undefined}
                    onClick={handleClicks}
                  >
                    <FileDownloadIcon />
                    Download
                  </button>}
                  <Menu
                    id="basic-menu"
                    anchorEl={downloadEl}
                    open={download}
                    onClose={handleCloses}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >

                    <MenuItem onClick={() => openConfirmModal("header")}>
                      Header Level Excel
                    </MenuItem>


                    <MenuItem onClick={() => openConfirmModal("line-item")}>
                      Line Item Level Excel
                    </MenuItem>


                    <MenuItem onClick={() => openConfirmModal("po-pdf")}>
                      PO PDF
                    </MenuItem>

                  </Menu>
                </div>
              </div>
            </div>
            <div className="account_ledger_listing_row1">
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Purchase Order
                    </label>
                    <p className="block_detail_listing">
                      <b>{summary?.total}</b>
                    </p>
                  </div>
                  <img className="purchase_images_letscom"
                    src={purchaseImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Pending Order
                    </label>
                    <p className="block_detail_listing">
                      <b>{summary?.pending}</b>
                    </p>
                  </div>
           <img className="purchase_images_letscom"
                    src={pendingImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Shipped Order
                    </label>
                    <p className="block_detail_listing">
                      <b>{summary?.shipped}</b>
                    </p>
                  </div>
                <img className="purchase_images_letscom"
                    src={shippedImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Completed Order
                    </label>
                    <p className="block_detail_listing">
                      <b>{summary?.completed}</b>
                    </p>
                  </div>
                 <img className="purchase_images_letscom"
                    src={completedImage}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"

                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="bpdt_po_order_react">
                <div>
                  <button className="btn btn-outline-secondary" onClick={handleTrackOrder}>Track Order</button>
                  <Drawer
                    anchor="right"
                    open={state.open}
                    onClose={toggleDrawer(false)}
                    style={{ zIndex: 99999 }}
                  >
                    {DrawerList}
                  </Drawer>
                </div>

                <div className="row_filterrbtnvendor_box">
                  <div className="lets_filter_vendorlist_body_detail">
                    <FilterAltOutlinedIcon />
                    <Filter uniqueName={userRole == "VENDOR" ? "PURCHASE_ORDER_VENDOR" : "PURCHASE_ORDER_INTERNAL"} formSubmitFunction={handleFilterFormSubmit} resetFilter={handleResetFormSubmit} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <div className="listing_main listing_main_dragdropcontext_body" style={{ width: "100%", overflow: "hidden" }}>
              <table className="dragdropcontext_ondragend_block_row">
                <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                  <Droppable droppableId="droppable" direction="horizontal">
                    {(provided) => (
                      <tr {...provided.droppableProps} ref={provided.innerRef}>
                        <th className="vendor_tabels">
                          {/* <input type="checkbox" /> */}
                        </th>
                        {columns.map((column, index) => (
                          <Draggable
                            key={column.id}
                            draggableId={column.id}
                            index={index}
                          >
                            {(provided) => (
                              <th className="vendor_tabels"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {column.label}

                                {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                  {/* <SwapVertIcon className="swap-sort-ico" /> */}
                                  {(column.sortLabel != "asc") && <img src={topArrow} />}
                                  {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                  {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                  {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}

                              </th>
                            )}
                          </Draggable>

                        ))}
                        {provided.placeholder}
                      </tr>
                    )}
                  </Droppable>
                </thead>
                <tbody style={{ overflowY: "scroll", width: "200px" }}>
                  {polisting?.purchaseOrders.length < 1 && <>
                    <tr>
                      <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                    </tr>
                  </>}
                  {polisting?.purchaseOrders?.map((row, rowIndex) => (
                    <tr key={row.poNumber} className="maine_tr_vendor">
                      <td>
                        <input type="checkbox" checked={row.isChecked} onChange={(e) => onPOCheckChange(e.target.checked, row, rowIndex)} />
                      </td>
                      {columns.map((column, index) => (<>
                        {(column.id == "poNumber") ? (<td>
                          <p className="list-details-para" onClick={() => redirectToDetails(row?._id)}>
                            {row[column.id]}
                          </p>
                        </td>) : (column.formate == "DATE") ? (<td>
                          <p  >
                            {isEmptyDash(row[column.id]) ? "N/A" : strToDate(row[column.id])}
                          </p>
                        </td>) : (column.formate == "QTY") ? (<td>
                          <p  >
                            {isEmptyDash(row[column.id]) ? "-" : row[column.id]}
                          </p>
                        </td>) :
                          (column?.formate == "RATE") ?
                          <td> 
                            {returnRateVal(row[column?.id])}
                            {/* ₹{totalInr(returnZero(row[column?.id]))}  */}
                            </td> :
                          <td key={index} >
                            <Tooltip title={row[column.id] || "N/A"}>
                            {trimString(row[column.id], 20 || "N/A")}
                            </Tooltip>
                          </td>
                        }

                        {/* <td key={column.id}>{row[column.id]}</td> */}
                      </>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </DragDropContext>

          {polisting?.purchaseOrders.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
              <div className="pagination_select_react_packagelr_detail">
                <select
                  className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayload?.pageSize}
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(polisting?.pageSize) * Number(polisting?.currentPage - 1) + 1} to ${Number(polisting?.pageSize) * Number(polisting?.currentPage - 1) + Number(polisting?.purchaseOrders.length)} of ${polisting?.totalItems}`}
                </span>
              </div>
              {/* <Stack spacing={2}>
                <Pagination
                  count={polisting?.totalPages}
                  page={polisting?.currentPage}
                  onChange={onPaginationChange}
                  renderItem={(item) => (<>
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  </>
                  )}
                />
              </Stack> */}

              <Stack spacing={2}>
                <Pagination
                  count={polisting?.totalPages}
                  page={polisting?.currentPage}
                  onChange={(event, page) => {
                    setInputPage(page);
                    onPaginationChange(event, page);
                  }}
                  renderItem={(item) => {
                    if (item.page === polisting?.currentPage) {
                      return (
                        <input
                          className="form-control"
                          type="text"
                          value={inputPage}
                          onChange={handleInputChange}
                          onKeyDown={handleInputSubmit}
                          style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                        />
                      );
                    }
                    return (
                      <PaginationItem
                        className="pagination_react_listings"
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                      />
                    );
                  }}
                />
              </Stack>
            </div>
          </>}

          {/* Approve Modal Buyer Po */}
          {userRole === "MANAGER" ? (
            <Modal
              open={openapprovepurchasetModal}
              onClose={() => setOpenApprovePurchaseModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenApprovePurchaseModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_Manager_bidding">
                    Are you sure you want to "<b>Approve</b>" selected purchase
                    order? PO No. :<b>00701</b> | PO Amount : <b>₹35,600</b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenApprovePurchaseModal(false);
                        setOpenApproveSucessfullyModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenApprovePurchaseModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}

          {/* Approve sucessfully Modal  */}
          {userRole === "MANAGER" ? (
            <Modal
              open={openapprovesucessfullyModal}
              onClose={() => setOpenApproveSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenApproveSucessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={checkcircleImage} alt="" />
                      <p className="profile_react_block">
                        Selected PO has been "<b>Approved</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => setOpenApproveSucessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Approve Bukl Modal Buyer Po */}
          {userRole === "BUYER" ? (
            <Modal
              open={openapprovebulkModal}
              onClose={() => setOpenApproveBulkModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenApproveBulkModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p className="project_Manager_bidding">
                    You are performing this action in bulk with selected
                    Purchase Orders. Are you sure you want to "<b>Approve</b>"
                    selected purchase orders?
                  </p>
                  <p className="profile_react_blocks">
                    Total PO Selected : <b>15 |</b> PO Amount :<b> ₹35,600 |</b>{" "}
                    PO Qty : <b>12</b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenApproveBulkModal(false);
                        setOpenConfirmationDetails(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenApproveBulkModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Request E-Sign  Modal Buyer Po */}
          {userRole === "BUYER" ? (
            <Modal
              open={openrequestedeasysignModal}
              onClose={() => setOpenRequestedEasySignModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenRequestedEasySignModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p className="project_Manager_bidding">
                    Request has been submitted for<b> E-Sign</b>
                  </p>

                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenRequestedEasySignModal(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/*E-Sign  Modal Buyer Po */}
          {/* {userRole === "VENDOR" || userRole === "MANAGER" ? (
            <Modal
              open={openesignpdfmodal}
              onClose={() => setopenESignPdfModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    PDF Preview
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setopenESignPdfModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <div className="esignpdf_lets_vendor_react_images">
                    <img src={esignpdfImages} alt="" />
                  </div>

                  <div className="all_btn_modal_listings">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setopenESignPdfModal(false);
                      }}
                    >
                      Submit
                    </button>
                    <button
                      href="onboarding_status.html"
                      className="view_lstings"
                      onClick={() => setopenESignPdfModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null} */}

          {/*Realse Add Custom T&C Modal */}
          <Modal
            open={opencustomtscmodal}
            onClose={() => setOpenCusTomtscModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Add Custom T&C
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCusTomtscModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <div className="message-body-bbdt">
                  <textarea
                    style={{ height: "20vh" }}
                    name="Message"
                    id="address"
                    class="form-control message-body_bbdt"
                    spellcheck="false"
                  ></textarea>
                </div>
              </div>
              <div className="table_btn_failed_sucess_purchase">
                <button
                  type="button"
                  class="btn btn-success save_next_btns"
                  fdprocessedid="cn5f6"
                  onClick={() => {
                    setOpenCusTomtscModal(false);
                    setOpenCustomTscModalSuccessfully(true);
                  }}
                >
                  Submit
                </button>
              </div>
            </Box>
          </Modal>
          {/* Hold Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openholdModal}
              onClose={() => setOpenHoldModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHoldModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p className="project_Manager_bidding">
                    Are you sure you want to "<b>Hold</b>" selected purchase
                    order?
                  </p>
                  <p className="profile_react_blocks">
                    Total PO Selected : <b>15 |</b> PO Amount :<b> ₹35,600 </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenHoldModal(false);
                        setOpenHoldSucessfullyModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenHoldModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Hold sucessfully Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openholdsucessfullyModal}
              onClose={() => setOpenHoldSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHoldSucessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={holdImage} alt="" />
                      <p className="profile_react_block">
                        Selected PO has been "<b>Hold</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => setOpenHoldSucessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Hold Bukl Modal Buyer Po */}
          <Modal
            open={openholdbulkModal}
            onClose={() => setOpenHoldBulkModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenHoldBulkModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p className="project_Manager_bidding">
                  You are performing this action in bulk with selected Purchase
                  Orders. Are you sure you want to "<b>Hold</b>" selected
                  purchase orders?
                </p>
                <p className="profile_react_blocks">
                  Total PO Selected : <b>15 |</b> PO Amount :<b> ₹35,600 |</b>{" "}
                  PO Qty : <b>12</b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenHoldBulkModal(false);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenHoldBulkModal(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Rejected Modal  */}
          {userRole === "BUYER" || userRole === "VENDOR" ? (
            <Modal
              open={openrejectedModal}
              onClose={() => setOpenRejectedModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenRejectedModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p className="project_Manager_bidding">
                    Are you sure you want to "<b>Reject</b>" selected purchase
                    order?
                  </p>
                  {/* <p className="profile_react_blocks">
                    Total PO Selected : <b>15 |</b> PO Amount :<b> ₹35,600 </b>
                  </p> */}
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={poTakeAction}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenRejectedModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Reject sucessfully Modal  */}
          {userRole === "BUYER" || userRole === "VENDOR" ? (
            <Modal
              open={openrejectedsucessfullyModal}
              onClose={() => setOpenRejectedSuccessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenRejectedSuccessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={rejectImage} alt="" />
                      <p className="profile_react_block">
                        Selected PO has been "<b>Reject</b>" Successfully
                      </p>
                      {/* <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p> */}
                      <button
                        className="view_progresse"
                        onClick={() => setOpenRejectedSuccessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Reject Bukl Modal Buyer Po */}
          <Modal
            open={openrejectedbulkModal}
            onClose={() => setOpenRejectedBulkModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRejectedBulkModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p className="project_Manager_bidding">
                  You are performing this action in bulk with selected Purchase
                  Orders. Are you sure you want to "<b>Reject</b>" selected
                  purchase orders?
                </p>
                <p className="profile_react_blocks">
                  Total PO Selected : <b>15 |</b> PO Amount :<b> ₹35,600 |</b>{" "}
                  PO Qty : <b>12</b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenRejectedBulkModal(false);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenRejectedBulkModal(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Released  Modal  */}
          {/* {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openrreleasedModal}
              onClose={() => setOpenReleasedModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenReleasedModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={releasedImage} alt="" />
                      <p className="profile_react_block">
                        Selected PO has been "<b>Released</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => {
                          setOpenReleasedModal(false);
                          setOpenReleasedSuccessfullyModal(true);
                        }}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null} */}
          {/* Released Successfully  Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openrreleasedsuccessfullyModal}
              onClose={() => setOpenReleasedSuccessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenReleasedSuccessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={checkcircleImage} alt="" />
                      <p className="profile_react_block">
                        All selected PO have been updated successfully.
                      </p>
                      {/* <p className="profile_react_blocks">
                        Total PO Selected. : <b>15 |</b> PO Updated :<b>15</b>
                      </p>
                      <p className="profile_react_blocks">
                        PO Total Amount : <b>₹35,600 |</b> PO Total Qty :{" "}
                        <b>12</b>
                      </p> */}
                      <button
                        className="view_progresse"
                        onClick={() => setOpenReleasedSuccessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/*PO Confirmation Details Modal  */}
          {userRole === "BUYER" ? (
            <Modal
              open={openconfirmationdetails}
              onClose={() => setOpenConfirmationDetails(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style2} className="modal_react_controlpanel_employees">
                <div className="modal-headeres">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    PO Confirmation Details
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenConfirmationDetails(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div
                    className="listing_main"
                    style={{
                      overflowX: "scroll",
                      overflowY: "scroll",
                      height: "40vh",
                    }}
                  >
                    <table>
                      <thead>
                        <tr>
                          <th
                            colSpan={3}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p className="success_text_purchase_react">
                              Successful PO
                            </p>
                          </th>
                          <th
                            colSpan={3}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p className="failed_text_purchase_react">
                              Failed PO
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <thead>
                        <tr>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              Product ID
                            </p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              PO Qty
                            </p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              PO Amount
                            </p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              Product ID
                            </p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              PO Qty
                            </p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              PO Amount
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00701
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹35,600
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            07001
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td>₹35,600</td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00702
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹35,600
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            07002
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td>₹35,600</td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00703
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹35,600
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            07003
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td>₹35,600</td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00704
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹35,600
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            07004
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td>₹35,600</td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00705
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹35,600
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            07005
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td>₹35,600</td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00706
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹35,600
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            07006
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td>₹35,600</td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00707
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹35,600
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            07007
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td>₹35,600</td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00708
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹35,600
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            07008
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            4
                          </td>
                          <td>₹35,600</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="table_btn_failed_sucess_purchase">
                    <button
                      onClick={() => setOpenConfirmationDetails(false)}
                      className="view_failed"
                    >
                      View Failed PO
                    </button>
                    <button
                      onClick={() => setOpenConfirmationDetails(false)}
                      className="view_success"
                    >
                      View Success PO
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/*Extend Validity PO Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openextendvalidityremarksmodal}
              onClose={() => setOpenExtendValidityRemarksModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                sx={extendvaliditystyle1}
                className="modal_react_controlpanel_employees"
              >
                <div className="modal-headeres">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Extend Validity
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenExtendValidityRemarksModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div
                    className="listing_main"
                    style={{
                      overflowY: "scroll",
                      height: "40vh",
                    }}
                  >
                    <table>
                      <thead>
                        <tr>
                          <th
                            colSpan={1}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p>PO No.</p>
                          </th>
                          <th
                            colSpan={2}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p>Current Validity</p>
                          </th>
                          <th
                            colSpan={2}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p>New Validity</p>
                          </th>
                          <th
                            colSpan={1}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <div className="remarks_bdbt_div_react_validity">
                              <p>
                                Remarks <span className="error">*</span>{" "}
                              </p>
                              <ContentCopyIcon />
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <thead>
                        <tr>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer"></p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">From</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">To</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">From</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">To</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer"></p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00701
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-01-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00702
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-03-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00703
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-03-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-04-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00704
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-05-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-06-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00705
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-06-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00706
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-07-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-08-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00707
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-04-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-07-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00708
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-08-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-09-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="table_btn_failed_sucess_purchase">
                    <button
                      onClick={() => setOpenExtendValidityRemarksModal(false)}
                      className="view_success"
                    >
                      Discard
                    </button>
                    <button
                      onClick={() => setOpenExtendValidityRemarksModal(false)}
                      className="view_failed"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}

          {/*Extend Validity PO Modal  */}
          {/*Add Milstone  Modal  */}
          {/* {userRole === "BUYER" ? (
            <Modal
              open={openaddmilestonepaymentmodal}
              onClose={() => setOpenAddMilestonePaymentModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style2} className="modal_react_controlpanel_employees">
                <div className="modal-headeres">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Add Milestone
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenAddMilestonePaymentModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div
                    className="listing_main"
                    style={{
                      overflowX: "scroll",
                      overflowY: "scroll",
                      height: "40vh",
                    }}
                  >
                    <table>
                      <thead>
                        <tr>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              Milestone
                            </p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              Milestone (%)
                            </p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              Payment
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            <select
                              class="form-select package_creation_form_milestone"
                              aria-label="Default select example"
                              fdprocessedid="zlera"
                            >
                              <option>Milestone One</option>
                              <option value="1">Select 1</option>
                              <option value="2">Select 2</option>
                            </select>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <div className="input_div_react_percentage">
                              <input
                                class="form-control form-haswe-milestone"
                                type="text"
                                fdprocessedid="93wdif"
                              />
                              <PercentOutlinedIcon />
                            </div>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹35,600
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            <select
                              class="form-select package_creation_form_milestone"
                              aria-label="Default select example"
                              fdprocessedid="zlera"
                            >
                              <option>Milestone two</option>
                              <option value="1">Select 1</option>
                              <option value="2">Select 2</option>
                            </select>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <div className="input_div_react_percentage">
                              <input
                                class="form-control form-haswe-milestone"
                                type="text"
                                fdprocessedid="93wdif"
                              />
                              <PercentOutlinedIcon />
                            </div>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹65,600
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            <select
                              class="form-select package_creation_form_milestone"
                              aria-label="Default select example"
                              fdprocessedid="zlera"
                            >
                              <option>Milestone three</option>
                              <option value="1">Select 1</option>
                              <option value="2">Select 2</option>
                            </select>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <div className="input_div_react_percentage">
                              <input
                                class="form-control form-haswe-milestone"
                                type="text"
                                fdprocessedid="93wdif"
                              />
                              <PercentOutlinedIcon />
                            </div>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹14,600
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            <select
                              class="form-select package_creation_form_milestone"
                              aria-label="Default select example"
                              fdprocessedid="zlera"
                            >
                              <option>Milestone four</option>
                              <option value="1">Select 1</option>
                              <option value="2">Select 2</option>
                            </select>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <div className="input_div_react_percentage">
                              <input
                                class="form-control form-haswe-milestone"
                                type="text"
                                fdprocessedid="93wdif"
                              />
                              <PercentOutlinedIcon />
                            </div>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹35,600
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            <select
                              class="form-select package_creation_form_milestone"
                              aria-label="Default select example"
                              fdprocessedid="zlera"
                            >
                              <option>Milestone five</option>
                              <option value="1">Select 1</option>
                              <option value="2">Select 2</option>
                            </select>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <div className="input_div_react_percentage">
                              <input
                                class="form-control form-haswe-milestone"
                                type="text"
                                fdprocessedid="93wdif"
                              />
                              <PercentOutlinedIcon />
                            </div>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹75,600
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            <select
                              class="form-select package_creation_form_milestone"
                              aria-label="Default select example"
                              fdprocessedid="zlera"
                            >
                              <option>Milestone six</option>
                              <option value="1">Select 1</option>
                              <option value="2">Select 2</option>
                            </select>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <div className="input_div_react_percentage">
                              <input
                                class="form-control form-haswe-milestone"
                                type="text"
                                fdprocessedid="93wdif"
                              />
                              <PercentOutlinedIcon />
                            </div>
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹45,600
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order"></td>
                          <td className="lets_table_blocklist_react_orders_milestone">
                            Total :
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            ₹240,500
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
                  </div>
                  <div className="table_btn_failed_sucess_purchase">
                    <button
                      type="button"
                      class="btn btn-success save_next_btns"
                      fdprocessedid="cn5f6"
                      onClick={() => {
                        setOpenAddMilestonePaymentModal(false);
                        setOpenMilestoneSuccessfullyModal(true);
                      }}
                    >
                      Save & Next
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null} */}
          {/*Add Milstone Successfully  Modal Buyer Po */}
          {userRole === "BUYER" ? (
            <Modal
              open={openmilestonesuccessfullymodal}
              onClose={() => setOpenMilestoneSuccessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenMilestoneSuccessfullyModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p className="project_Manager_bidding">
                    Request for E-Sign Sent Successfully
                  </p>

                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenMilestoneSuccessfullyModal(false);
                        // setOpenAddMildStoneModals(true);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/*Add Custome T&C Successfully  Modal Buyer Po */}
          {userRole === "BUYER" ? (
            <Modal
              open={opencustomtscmodalsuccessfully}
              onClose={() => setOpenCustomTscModalSuccessfully(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenCustomTscModalSuccessfully(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p className="project_Manager_bidding">
                    Custom T&C has been Successfully Submit
                  </p>

                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenCustomTscModalSuccessfully(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Realse E-sign Modal Buyer Po */}
          <Modal
            open={openrelaseesignmodals}
            onClose={() => setopenRelaseESignModals(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setopenRelaseESignModals(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_Manager_bidding">
                  Are you sure you want to <b>Realse E- Sign</b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setopenRelaseESignModals(false);
                      setopenRelaseESignSuccessModals(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => {
                      setopenRelaseESignModals(false);
                      setopenRelaseESignRejectedModals(true);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Realse E-sign Success Modal Buyer Po */}
          <Modal
            open={openrelaseesignsuccessmodals}
            onClose={() => setopenRelaseESignSuccessModals(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setopenRelaseESignSuccessModals(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p class="project_Manager_bidding">
                  <b>Realse E- Sign</b> has been successfully
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setopenRelaseESignSuccessModals(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Realse E-sign Rejected Modal Buyer Po */}
          <Modal
            open={openrelaseesignrejectedmodals}
            onClose={() => setopenRelaseESignRejectedModals(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setopenRelaseESignRejectedModals(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={rejectImage} alt="" />
                <p class="project_Manager_bidding">
                  <b> Realse E- Sign</b> has not been completed
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setopenRelaseESignRejectedModals(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          {/* Header Level Excel Purchase listing */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openheaderlevelexcelmodal}
              onClose={closeConfirmModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelExcelModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_Manager_bidding">
                    Are you sure you want to download
                    <br /> {confirmObj?.text}
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={downloadPO}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={closeConfirmModal}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Header Level Sucessfully Purchase listing */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openheaderlevelsucessfullymodal}
              onClose={() => setOpenHeaderLevelSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelSucessfullyModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p class="project_Manager_bidding">
                    Selected <b>{confirmObj?.text}</b> file has been
                    <br /> downloaded successfully.
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenHeaderLevelSucessfullyModal(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Header Level Rejected Purchase listing
          <Modal
            open={openheaderlevelrejectedmodal}
            onClose={() => setOpenHeaderLevelRejectedModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenHeaderLevelRejectedModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={rejectImage} alt="" />
                <p class="project_Manager_bidding">
                  Selected <b>Header Level</b> has been
                  <br /> Rejected download
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenHeaderLevelRejectedModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* Line Item Level Excel Purchase order */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openlineitemlevelexcelmodal}
              onClose={() => setOpenLineItemLevelExcelModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenLineItemLevelExcelModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_Manager_bidding">
                    Are you sure you want to download
                    <br /> Line Item Level Excel
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={downloadPO}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => {
                        setOpenLineItemLevelExcelModal(false);
                      }}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Line Item Level Excel Sucessfully  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openlineitemlevelsuccessmodal}
              onClose={() => setOpenLineItemLevelSuccessModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenLineItemLevelSuccessModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p class="project_Manager_bidding">
                    Selected <b>Line Item Excel</b> file has been
                    <br /> downloaded successfully.
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenLineItemLevelSuccessModal(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Line Item Level Excel Rejected Purchase listing */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openlineitemlevelrejectedmodal}
              onClose={() => setOpenLineItemLevelRejectedModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenLineItemLevelRejectedModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={rejectImage} alt="" />
                  <p class="project_Manager_bidding">
                    Selected <b>Line Item</b> has been
                    <br /> Rejected download
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenLineItemLevelRejectedModal(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* PO PDF Modal Buyer Po */}
          {userRole === "BUYER" || userRole === "Manager" ? (
            <Modal
              open={openpopdfpurchasemodal}
              onClose={() => setOpenPoPdfPurchaseModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenPoPdfPurchaseModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_Manager_bidding">
                    Are you sure you want to download PO Pdf
                    <br />
                    <b>PO No. : 00701 </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      className="view_progresse"
                      onClick={() => {
                        setOpenPoPdfPurchaseModal(false);
                        setOpenPoPdfPurchaseSuccessModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      className="view_lsting"
                      onClick={() => {
                        setOpenPoPdfPurchaseModal(false);
                        setOpenPoPdfPurchaseRejectedModal(true);
                      }}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* PO PDF Successfully Modal Buyer Po */}
          {userRole === "BUYER" || userRole === "Manager" ? (
            <Modal
              open={openpopdfpurchasesuccessmodal}
              onClose={() => setOpenPoPdfPurchaseSuccessModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenPoPdfPurchaseSuccessModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p class="project_Manager_bidding">
                    Selected PO has been "<b>PDF Download</b>" Successfully
                    <br />
                    <b>PO No. : 07001 </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenPoPdfPurchaseSuccessModal(false);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* PO PDF Rejected Modal Buyer Po */}
          {userRole === "BUYER" || userRole === "Manager" ? (
            <Modal
              open={openpopdfpurchaserejectedmodal}
              onClose={() => setOpenPoPdfPurchaseRejectedModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenPoPdfPurchaseRejectedModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={rejectImage} alt="" />
                  <p class="project_Manager_bidding">
                    Selected PO has been "<b>PDF Download</b>" failed
                    <br />
                    <b>PO No. : 07001 </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      className="view_progresse"
                      onClick={() => {
                        setOpenPoPdfPurchaseRejectedModal(false);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Release Modal */}
          <Modal
            open={openreleaseorderpurchase}
            onClose={() => setOpenReleaseOrderPurchase(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Release
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenReleaseOrderPurchase(false)}
                ></button>
              </div>
              <div class="modal-body">
                <p class="project_Manager_biddings">Signed PO PDF</p>
                <div className="from_input_realse">
                  <input
                    class="form-control form-h choose"
                    type="file"
                    id="checklist-fileInput"
                    accept=".bmp,.gif,.jpg,.jpeg,.png,.tiff,.psd,.svg,.eps,.ai,.pdf"
                  />
                </div>
                <div className="all_btn_import">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setOpenReleaseOrderPurchase(false);
                    }}
                  >
                    Discard
                  </button>
                  <button
                    className="btn btn-outline-warning"
                    onClick={() => {
                      setOpenReleaseOrderPurchase(false);
                      setOpenReleaseOrderPurchasePdf(true);
                    }}
                  >
                    Import
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={openreleaseorderpurchasepdf}
            onClose={() => setOpenReleaseOrderPurchasePdf(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Release
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenReleaseOrderPurchasePdf(false)}
                ></button>
              </div>
              <div class="modal-body">
                <div className="esignpdf_lets_vendor_react_images">
                  <img src={esignpdfImages} alt="" />
                </div>
                <div className="all_btn_import">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setOpenReleaseOrderPurchasePdf(false);
                    }}
                  >
                    Discard
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      setOpenReleaseOrderPurchasePdf(false);
                      setOpenReleaseOrderMessagePdf(true);
                    }}
                  >
                    Release
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          <Modal
            open={openreleaseordermessagepdf}
            onClose={() => setOpenReleaseOrderMessagePdf(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenReleaseOrderMessagePdf(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p>Are you sure you want to continue</p>
                <div className="all_btn_modal_listing">
                  <button
                    className="view_lsting"
                    onClick={() => {
                      setOpenReleaseOrderMessagePdf(false);
                    }}
                  >
                    No
                  </button>
                  <button
                    className="view_progresse"
                    onClick={() => {
                      setOpenReleaseOrderMessagePdf(false);
                      setOpenReleaseOrderSuccessMessage(true);
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={openreleaseordersuccessmessage}
            onClose={() => setOpenReleaseOrderSuccessMessage(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenReleaseOrderSuccessMessage(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkcircleImage} alt="" />
                <p>PO Released Successfully</p>
                <div className="all_btn_modal_listing">
                  <button
                    className="view_progresse"
                    onClick={() => {
                      setOpenReleaseOrderSuccessMessage(false);
                    }}
                  >
                    Okay
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Release Modal */}
          {/* Undo Release Modal */}
          <Modal
            open={openundoreleasemodal}
            onClose={() => setOpenUndoReleaseModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenUndoReleaseModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p>Are you sure you want to Undo this Release</p>
                <div className="all_btn_modal_listing">
                  <button
                    className="view_progresse"
                    onClick={poTakeAction}
                  >
                    Yes
                  </button>
                  <button
                    className="view_lsting"
                    onClick={() => {
                      setOpenUndoReleaseModal(false);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Undor Release Modal */}
          {/* Approve E-Sign Modal */}
          <Modal
            open={openapproveesign}
            onClose={() => setOpenApproveEsign(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenApproveEsign(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p>Are you sure you want to Approve ?</p>
                <div className="all_btn_modal_listing">
                  <button
                    className="view_lsting"
                    onClick={() => {
                      setOpenApproveEsign(false);
                    }}
                  >
                    No
                  </button>
                  <button
                    className="view_progresse"
                    onClick={() => {
                      setOpenApproveEsign(false);
                      setOpenApproveEsignSuccessModal(true);
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={openapproveesignsucessmodal}
            onClose={() => setOpenApproveEsignSuccessModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenApproveEsignSuccessModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p>
                  Selected PO has been <b>"E-Signed"</b> Successfully
                </p>
                <p className="modal_bodys_esignsuccess">
                  PO No. :<b> 07001</b> | PO Amount : <b>₹35,600</b> | PO Qty :{" "}
                  <b>12</b>
                </p>

                <div className="all_btn_modal_listing">
                  <button
                    className="view_progresse"
                    onClick={() => {
                      setOpenApproveEsignSuccessModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Approve E-Sign Modal */}
          {/* Hold E-Sign Modal */}
          <Modal
            open={opemholdesignmodal}
            onClose={() => setOpemHoldESignModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpemHoldESignModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p>Are you sure you want to "<b>Hold</b>" selected purchase order for E-Sign?
                  PO No. : <b>00701</b> | PO Amount : <b>₹35,600</b></p>
                <div className="all_btn_modal_listing">
                  <button
                    className="view_lsting"
                    onClick={() => {
                      setOpemHoldESignModal(false);
                    }}
                  >
                    No
                  </button>
                  <button
                    className="view_progresse"
                    onClick={() => {
                      setOpemHoldESignModal(false);
                      setOpemHoldESignModalSuccess(true);
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={opemholdesignmodalsuccess}
            onClose={() => setOpemHoldESignModalSuccess(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpemHoldESignModalSuccess(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={holdImage} alt="" />
                <p>
                  Selected PO has been <b>"Hold"</b> Successfully
                </p>
                <p className="modal_bodys_esignsuccess">
                  PO No. :<b> 07001</b> | PO Amount : <b>₹35,600</b> | PO Qty :{" "}
                  <b>12</b>
                </p>

                <div className="all_btn_modal_listing">
                  <button
                    className="view_progresse"
                    onClick={() => {
                      setOpemHoldESignModalSuccess(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Hold E-Sign Modal */}
          {/* Reject E-Sign Modal */}
          <Modal
            open={opemrejectesignmodal}
            onClose={() => setOpemRejectESignModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpemRejectESignModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p>Are you sure you want to "<b>Reject</b>" selected purchase<br /> order for E-Sign?<br />
                  PO No. : <b>00701</b> | PO Amount : <b>₹35,600</b></p>
                <div className="all_btn_modal_listing">
                  <button
                    className="view_lsting"
                    onClick={() => {
                      setOpemRejectESignModal(false);
                    }}
                  >
                    No
                  </button>
                  <button
                    className="view_progresse"
                    onClick={() => {
                      setOpemRejectESignModal(false);
                      setOpemRejectESignModalSuccess(true);
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={opemrejectesignmodalsuccess}
            onClose={() => setOpemRejectESignModalSuccess(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpemRejectESignModalSuccess(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={rejectImage} alt="" />
                <p>
                  Selected PO has been <b>"Rejected"</b> Successfully
                </p>
                <p className="modal_bodys_esignsuccess">
                  PO No. :<b> 07001</b> | PO Amount : <b>₹35,600</b> | PO Qty :{" "}
                  <b>12</b>
                </p>

                <div className="all_btn_modal_listing">
                  <button
                    className="view_progresse"
                    onClick={() => {
                      setOpemRejectESignModalSuccess(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          {/* Reject E-Sign Modal */}
        </div>
      </div>

      <RequestSignModal
        isOpen={openaddmildstonemodals}
        openRequestSign={openRequestSign}
        closeRequestSign={closeRequestSign}
        purchaseOrderIds={selectedPOArr?.[0]}
        poDetails={poDetails}
        submitSign={submitSign}
      />

      <PDFPreview
        isOpen={openesignpdfmodal}
        openRequestSign={openPdfPreview}
        closeRequestSign={closePdfPreview}
        purchaseOrderIds={selectedPOArr?.[0]}
        poDetails={poDetails}
        submitSign={submitPdfPreview}
      />

      <POReleaseModal
        isOpen={openrreleasedModal}
        openRequestSign={openReleaseModal}
        closeReleaseModal={closeReleaseModal}
        purchaseOrderIds={selectedPOArr}
        submitRelease={uploadFile}
      />

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default PurchaseOrder;
